<!--
 * @Author: baike
 * @LastEditors: baike
-->
<template>
  <div class="banner">
    <div class="left_btn" @click="edd"></div>
    <div class="right_btn" @click="add"></div>
    <div class="banner_top">
      <div v-for="(item, index) in Year" :key="item" class="top_b_li">
        <div :id="index == indexNum ? 'rdios' : ''" class="rdios"></div>
        <div :id="index == indexNum ? 'year_text' : ''" class="year_text">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="banner_bom">
      <div class="banner_list">
        <div
          v-for="(item, index) in Banner"
          :key="item.year"
          :id="index == bomIndex ? 'bom_box' : ''"
          class="bom_box"
        >
          <div class="box_con">
            {{ item.text }}
          </div>
          <div class="time">
            {{ item.year }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      Year: [2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
      Banner: [
        {
          text: "公司正式成立",
          year: "2016",
        },
        {
          text: "积极拓展业务，与中国建筑、中国中冶等国有企业达成战略合作伙伴关系",
          year: "2017",
        },
        {
          text: "开展银行保函业务，积极与合作银行签订授信合同",
          year: "2018",
        },
        {
          text: "与中国建设银行、华商银行陆续达成战略合作伙伴关系，公司总银行额度30亿，业务不断扩展",
          year: "2019",
        },
        {
          text: "上线深圳交易中心电子保函业务，银行投标保函出函量居担保行业前列",
          year: "2020",
        },
        {
          text: "业务范围遍及全国各地，与华商银行推出电子保函，与多家交易中心合作，助力基建",
          year: "2021",
        },
        {
          text: "大力推进履约业务，建设银行、华商银行授信额度持续扩增全国分支机构达到20家",
          year: "2022",
        },
        {
          text: "与湖南国企合作，开展中信、浙商、民生、北京等银行保函业务全国分支及代理机构达到60余家，业务覆盖全国总部团队增加至40人，培养、打造综合业务能力强的团队",
          year: "2023",
        },
      ],
      indexNum: 0,
      CobyArray: [
        {
          text: "公司正式成立",
          year: "2016",
        },
        {
          text: "积极拓展业务，与中国建筑、中国中冶等国有企业达成战略合作伙伴关系",
          year: "2017",
        },
        {
          text: "开展银行保函业务，积极与合作银行签订授信合同",
          year: "2018",
        },
        {
          text: "与中国建设银行、华商银行陆续达成战略合作伙伴关系，公司总银行额度30亿，业务不断扩展",
          year: "2019",
        },
        {
          text: "上线深圳交易中心电子保函业务，银行投标保函出函量居担保行业前列",
          year: "2020",
        },
        {
          text: "业务范围遍及全国各地，与华商银行推出电子保函，与多家交易中心合作，助力基建",
          year: "2021",
        },
        {
          text: "大力推进履约业务，建设银行、华商银行授信额度持续扩增全国分支机构达到20家",
          year: "2022",
        },
        {
          text: "与湖南国企合作，开展中信、浙商、民生、北京等银行保函业务全国分支及代理机构达到60余家，业务覆盖全国总部团队增加至40人，培养、打造综合业务能力强的团队",
          year: "2023",
        },
      ],
      bomIndex: 0,
    };
  },
  mounted() {},
  methods: {
    add() {
      if (this.indexNum == 7) return;
      // top 上面得index
      this.indexNum = this.indexNum + 1;
      if (this.indexNum > 5) {
        this.bomIndex = this.bomIndex + 1;
      } else {
        // bom 得index
        this.bomIndex = 0;
        this.Banner.splice(this.bomIndex, 1);
      }
      this.$forceUpdate();
    },
    edd() {
      if (this.indexNum == 0) return;
      this.indexNum = this.indexNum - 1;

      if (this.indexNum < 5) {
        let eddArr = this.CobyArray.filter((i, index) => {
          return this.indexNum == index;
        });
        this.Banner = eddArr.concat(this.Banner);
      } else {
        this.bomIndex = this.bomIndex - 1;
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style lang='less' scoped>
.banner {
  position: relative;

  .left_btn {
    width: 60px;
    height: 60px;
    background: url("../../assets/info/left.png") no-repeat;
    background-position: center;
    background-size: cover;
    position: absolute;
    top: 45%;
    transform: translate(-50%);
    left: -50px;
    cursor: pointer;
  }
  .right_btn {
    width: 60px;
    height: 60px;
    background: url("../../assets/info/right.png") no-repeat;
    background-position: center;
    background-size: cover;
    position: absolute;
    top: 45%;
    transform: translate(-50%);
    right: -90px;
    cursor: pointer;
  }

  .banner_top {
    display: flex;
    .top_b_li {
      width: 147px;
      height: 2px;
      background: #e9e9e9;
      position: relative;
      .rdios {
        width: 11px;
        height: 10px;
        border: 2px solid #e66819;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        background: white;
        top: -4px;
      }
      #rdios {
        background: #e66819;
      }
      #year_text {
        font-size: 32px;
        font-family: DIN Medium, DIN Medium;
        font-weight: 400;
        color: #e66819;
      }
      .year_text {
        font-size: 20px;
        font-family: DIN, DIN;
        font-weight: 400;
        line-height: 32px;
        color: #999999;
        position: absolute;
        text-align: center;
        width: 100%;
        top: -50px;
      }
    }
  }
  .banner_bom {
    margin-top: 30px;
    overflow: hidden;
    .banner_list {
      display: flex;
      min-width: 3300px;
    }
    #bom_box {
      border: 2px solid #e66819;
    }
    .bom_box {
      width: 380px;
      height: 200px;
      border-radius: 5px 5px 5px 5px;
      opacity: 1;
      border: 1px solid #e9e9e9;
      margin-right: 20px;
      padding: 30px 56px;
      position: relative;
      .box_con {
        font-size: 14px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .time {
        font-size: 64px;
        font-family: DIN Medium, DIN Medium;
        font-weight: 400;
        color: rgba(230, 104, 25, 0.1);
        line-height: 80px;
        position: absolute;
        right: 27px;
        bottom: 10px;
      }
    }
  }
}
</style>